export const GET_WAITING_ROOM_DATA = "GET_WAITING_ROOM_DATA";
export const SAVE_WAITING_ROOM_DATA = "SAVE_WAITING_ROOM_DATA";
export const UPDATE_LOADING_STATUS_WAITING_ROOM = "UPDATE_LOADING_STATUS_WAITING_ROOM";
export const SELECT_PATIENT_FOR_EXAM = "SELECT_PATIENT_FOR_EXAM";
